import React, { useState, useEffect } from "react";
import { Button } from "devextreme-react/button";
import { TextBox } from "devextreme-react/text-box";
import { CheckBox } from "devextreme-react/check-box";
import { SelectBox } from "devextreme-react/select-box";
import { DateBox } from "devextreme-react/date-box";
import routes from "../../../assets/apiRoutes.json";
import { Popup } from "devextreme-react/popup";
import { Toast, Position } from "devextreme-react/toast";
import "./update.css";
import axios from "axios";
import { connect } from "react-redux";
var accessToken;

// Default order-selection filter values. Mirror the backend QueryUpdateFilterDTO defaults so the
// screen reflects exactly what the Update batch applies unless the user changes it.
const DEFAULT_FILTER = {
  itemCodePrefix: "T",
  includeTreeClass: false,
  treeClassCode: "TREE",
  lotSowYear: "", // empty = no sow-year filter (include all)
  lotCodeExclude: "NS", // exclude lots whose LOTCODE contains this; empty = no exclusion
  itemSpecies: "", // empty = no species filter (include all)
  creationDateFrom: null, // null = no lower bound on OMTRANSACTIONHEADER.CREATIONDATETIME
  creationDateTo: null, // null = no upper bound (inclusive through the selected day)
};

const Update = (props) => {
  accessToken = props.oidc.user.access_token;
  // Editable/transparent filter sent to the backend batch (was hard-coded in the query before).
  const [orderFilter, setOrderFilter] = useState({ ...DEFAULT_FILTER });
  const [sowYearOptions, setSowYearOptions] = useState([]);
  const [speciesOptions, setSpeciesOptions] = useState([]);
  const [disableUpdatebtn, setdisableUpdatebtn] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  // Load the distinct LOT sow years (IMLOT.USERDEFINEDCODE_2) and item species
  // (IMITEM.SUBCLASSCODE) for the filter dropdowns.
  useEffect(() => {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.pu_processing.GetLotSowYears}`,
        { headers: { access_token: accessToken } }
      )
      .then((res) => setSowYearOptions(res.data || []))
      .catch((err) => console.log(err, "error loading lot sow years"));

    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.pu_processing.GetItemSpecies}`,
        { headers: { access_token: accessToken } }
      )
      .then((res) => setSpeciesOptions(res.data || []))
      .catch((err) => console.log(err, "error loading item species"));
  }, []);
  const updateSoRecord = () => {
    setdisableUpdatebtn(true);
    setIsVisible(true);

    axios
      .post(
        `${window._env_.REACT_APP_APIS}/${routes.pu_processing.QueryUpdateList}`,
        orderFilter,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken
          }
        }
      )
      .then((res) => {
        setIsVisible(false);
        setdisableUpdatebtn(false);
        setOpenUpdateDialog(true);
        console.log(res, "res for update record");
      })
      .catch((err) => {
        console.log(err, "error in update record");
        setIsVisible(false);
      });
  };

  const closeUpdateDialog = () => {
    setOpenUpdateDialog(false);
  };
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  return (
    <div className="update-wrapper h-100">
      <div className="h-100 card-container dx-card m-0">
      <h6
                          style={{
                            color: window._env_.Color2,
                            paddingLeft:'10px',
                            paddingTop:'0px'
                          }}
                        >
                          Update Sod Record !
                        </h6>
        <div className="order-filter" style={{ padding: "10px", maxWidth: "420px" }}>
          <div style={{ marginBottom: "10px" }}>
            <div style={{ marginBottom: "4px", fontWeight: 600 }}>
              Item Code starts with
            </div>
            <TextBox
              value={orderFilter.itemCodePrefix}
              onValueChanged={(e) =>
                setOrderFilter((prev) => ({ ...prev, itemCodePrefix: e.value }))
              }
              placeholder="T"
              showClearButton={true}
            />
          </div>
          <CheckBox
            value={orderFilter.includeTreeClass}
            text={`Include items with Class Code = ${orderFilter.treeClassCode}`}
            onValueChanged={(e) =>
              setOrderFilter((prev) => ({ ...prev, includeTreeClass: e.value }))
            }
          />
          <div style={{ marginTop: "10px" }}>
            <div style={{ marginBottom: "4px", fontWeight: 600 }}>
              Lot Sow Year
            </div>
            <SelectBox
              dataSource={sowYearOptions}
              value={orderFilter.lotSowYear || null}
              onValueChanged={(e) =>
                setOrderFilter((prev) => ({ ...prev, lotSowYear: e.value || "" }))
              }
              placeholder="All sow years"
              showClearButton={true}
              searchEnabled={true}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <div style={{ marginBottom: "4px", fontWeight: 600 }}>
              Exclude lot codes containing
            </div>
            <TextBox
              value={orderFilter.lotCodeExclude}
              onValueChanged={(e) =>
                setOrderFilter((prev) => ({ ...prev, lotCodeExclude: e.value }))
              }
              placeholder="NS"
              showClearButton={true}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <div style={{ marginBottom: "4px", fontWeight: 600 }}>
              Item Species
            </div>
            <SelectBox
              dataSource={speciesOptions}
              value={orderFilter.itemSpecies || null}
              onValueChanged={(e) =>
                setOrderFilter((prev) => ({ ...prev, itemSpecies: e.value || "" }))
              }
              placeholder="All species"
              showClearButton={true}
              searchEnabled={true}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <div style={{ marginBottom: "4px", fontWeight: 600 }}>
              Sales Order Creation Date Range
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <DateBox
                type="date"
                value={orderFilter.creationDateFrom}
                onValueChanged={(e) =>
                  setOrderFilter((prev) => ({ ...prev, creationDateFrom: e.value }))
                }
                placeholder="From"
                showClearButton={true}
                max={orderFilter.creationDateTo || undefined}
              />
              <DateBox
                type="date"
                value={orderFilter.creationDateTo}
                onValueChanged={(e) =>
                  setOrderFilter((prev) => ({ ...prev, creationDateTo: e.value }))
                }
                placeholder="To"
                showClearButton={true}
                min={orderFilter.creationDateFrom || undefined}
              />
            </div>
          </div>
        </div>
        <Button
          onClick={updateSoRecord}
          type="default"
          disabled={disableUpdatebtn}
          id="container"
        >
          Update
        </Button>
        <Toast
          visible={isVisible}
          type="info"
          message="Update Process is in progress"
        >
          <Position my="bottom" at="bottom" of="#container" />
        </Toast>
      </div>
      <Popup
        visible={openUpdateDialog}
        dragEnabled={false}
        hideOnOutsideClick={true}
        showTitle={false}
        showCloseButton={false}
        title="Update Record"
        container=".dx-viewport"
        width={500}
        height={140}
      >
        <h6 className="update-dialog-title">Update Record !</h6>
        <p className="dialog-heading">
          Your Records has been updated successfully !
        </p>
        <Button
          text="Ok"
          type="default"
          onClick={closeUpdateDialog}
        />
      </Popup>
    </div>
  );
};

function mapStateToProps(state) {
  return {
      oidc: state.oidc
  };
}

export default connect(mapStateToProps)(Update);
